import * as _ from 'lodash';
import moment from 'moment';

export function getCurrentSeason(): Season {
    const currentMonth = moment().month();
    const currentYear = moment().year();

    return {
        name: currentMonth < 4 || currentMonth > 9 ? SeasonName.SpringSummer : SeasonName.FallWinter,
        year: currentMonth > 9 ? _.toString(currentYear + 1) : _.toString(currentYear)
    };
}

export function getUpcomingSeason(season?: Season): Season {
    season = season || getCurrentSeason();
    const seasonYear = _.parseInt(season.year);
    const isWinterSeason = season.name === SeasonName.FallWinter;

    return {
        name: isWinterSeason ? SeasonName.SpringSummer : SeasonName.FallWinter,
        year: isWinterSeason ? _.toString(seasonYear + 1) : _.toString(seasonYear)
    };
}

export function getUpcomingSeasons(amountOfUpcomingSeasons: number): Season[] {
    return _.reduce(
        new Array(amountOfUpcomingSeasons),
        (seasons) => [...seasons, getUpcomingSeason(_.last(seasons))],
        []
    );
}

export function getPreviousSeason(season?: Season): Season {
    season = season || getCurrentSeason();
    const seasonYear = _.parseInt(season.year);
    const isWinterSeason = season.name === SeasonName.FallWinter;

    return {
        name: isWinterSeason ? SeasonName.SpringSummer : SeasonName.FallWinter,
        year: isWinterSeason ? _.toString(seasonYear) : _.toString(seasonYear - 1)
    };
}

export function getPreviousSeasons(amountOfPreviousSeasons: number): Season[] {
    return _.reduce(
        new Array(amountOfPreviousSeasons),
        (seasons) => [...seasons, getPreviousSeason(_.last(seasons))],
        []
    );
}

export function getNosSeason(): Season {
    return { name: SeasonName.NOS, year: '' };
}

export function getOngoingSeason(): Season {
    return { name: SeasonName.Ongoing, year: '' };
}

export function mapSeasonToFacetKey(season: Season) {
    return isNOSSeason(season) ? season.name : `${season.name}${season.year}`;
}

export function mapSeasonToUrlParam(season: Season) {
    return isNOSSeason(season) ? season.name : `${season.name}|${season.year}`;
}

export function isNOSSeason(season: Season) {
    return season.name === SeasonName.NOS || !season.year;
}

export function isSeasonText(inputString: string): boolean {
    const pattern = /^(fall_winter|spring_summer)(20\d{2})?$|^(multiple_seasons|nos|ongoing)$/;
    return pattern.test(inputString);
}

export function getSeasonalTranslationDataFromText(name: string) {
    const splitIndex = name.search(/\d/);
    if (splitIndex !== -1) {
        const season = name.slice(0, splitIndex);
        const year = name.slice(splitIndex);
        return [seasonTranslationKeyMap[season], year];
    } else {
        return [seasonTranslationKeyMap[name]];
    }
}

export interface Season {
    name: SeasonName;
    year: string;
}

export enum SeasonName {
    FallWinter = 'fall_winter',
    SpringSummer = 'spring_summer',
    Multiple = 'multiple_seasons',
    NOS = 'nos',
    Ongoing = 'ongoing'
}

export enum SeasonTranslationFilterKey {
    FallWinter = 'MARKETING_FILES.FILTER.AUTUMN_WINTER_SEASON',
    SpringSummer = 'MARKETING_FILES.FILTER.SPRING_SUMMER_SEASON',
    Ongoing = 'MARKETING_FILES.FILTER.SEASON_ONGOING'
}

export enum SeasonTranslationKey {
    FallWinter = 'AUTUMN_WINTER_SEASON',
    SpringSummer = 'SPRING_SUMMER_SEASON',
    Ongoing = 'SEASON_ONGOING'
}

export const seasonTranslationKeyMap = {
    [SeasonName.SpringSummer]: 'SEASON_SPRING_SUMMER',
    [SeasonName.FallWinter]: 'SEASON_FALL_WINTER',
    [SeasonName.NOS]: 'NOS',
    [SeasonName.Ongoing]: 'SEASON_ONGOING'
};
